import { BankIdAuthenticationElements } from "@/components/bank-id/components/pending-authentication/bank-id-authentication-elements";
import { RefreshStatus } from "@/components/bank-id/components/utilities/refresh-status";
import type { CloseModalProps } from "@/components/bank-id/types";
import { BankIdLogo } from "@/components/bank-id/utilities/bank-id-logo";
import { VisuallyHiddenDialogDescription } from "@/components/bank-id/utilities/visually-hidden-dialog-description";
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useTranslations } from "@/hooks/use-translations";
import { AuthProcess } from "@/types";

export type PendingAuthenticationProps = CloseModalProps & {
  authProcess: AuthProcess;
};

export type OpenOnThisOtherDeviceProps = CloseModalProps & {
  handleSwitchDevice: (onThisDevice: boolean) => void;
};

export function PendingAuthentication({
  authProcess,
  closeModal,
}: PendingAuthenticationProps) {
  const { __ } = useTranslations();

  return (
    <DialogContent>
      <DialogHeader className={"grid-cols-4"}>
        <DialogTitle className={"col-span-3"}>
          <div className="flex w-full items-center">
            <BankIdLogo inverted={true} />
            <span className={"ml-4 text-lg lg:text-xl"}>
              {authProcess === AuthProcess.LogIn &&
                __("bank_id.identify_with_bank_id")}
              {authProcess === AuthProcess.Register &&
                __("bank_id.register_with_bank_id")}
            </span>
          </div>
        </DialogTitle>
      </DialogHeader>

      <VisuallyHiddenDialogDescription />

      <BankIdAuthenticationElements
        authProcess={authProcess}
        closeModal={closeModal}
      />

      <RefreshStatus />
    </DialogContent>
  );
}
